import { configureStore } from '@reduxjs/toolkit'
// import { counterSlice } from './slices/counter'
import { authSlice } from './slices/auth'
import { providerSlice } from './slices/provider'
import { projectsSlice } from './slices/projects'
import { profitSlice } from './slices/profit'


export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // ignoredActions: ['auth/setPaymentSlipsSort'],
        ignoredActionPaths: ['payload.buildRowData'],
        // ignoredPaths: ['items.dates'],
      },
    }),
  reducer: {
    // counter: counterSlice.reducer,
    auth: authSlice.reducer,
    provider: providerSlice.reducer,
    projects: projectsSlice.reducer,
    profit: profitSlice.reducer,

  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch